// extracted by mini-css-extract-plugin
module.exports = {"RifleSliderWrapper":"RifleSlider_RifleSliderWrapper__3tKS7","sliderOptions":"RifleSlider_sliderOptions__1RNqa"};